import React from 'react'
import { Input } from '@driftt/tide-core'

const selectAll = (bulkSelect, isChecked) => {
  return (
    <Input type="checkbox" checked={isChecked} onChange={bulkSelect} />
  )
}


export const AllSegmentsConstants = (bulkSelect, isChecked, onChange) => ([
  {
    label: selectAll(bulkSelect, isChecked),
    sortable: false,
    width: '20px'
  },
  {
    label: 'Segment name',
    sortable: false, // Setting all the following formerly "true" sortable columns to "false" until we actually do the work with state to sort things in ticket CRM-2248
    onClick: onChange,
    width: '350px'
  },
  {
    label: 'Segment type',
    sortable: false,
    onClick: onChange,
    width: '100px'
  },
  {
    label: 'Created by',
    sortable: false,
    onClick: onChange,
    width: '200px'
  },
  {
    label: 'Created on',
    sortable: false,
    onClick: onChange,
    width: '150px'
  },
  {
    label: 'Last updated',
    sortable: false,
    onClick: onChange,
    width: '150px'
  },
  {
    label: '',
    width: '50px'
  },
])
